import React from "react";

import SectionDynamicDogBase from "../SectionDynamicDogBase/SectionDynamicDogBase";

export interface SectionDynamicDogByAgeProps {
	title: string;
	htmlIntro?: string;
	currentDogId: string;
	maxItems: number;
	jumpLinksTitle?: string;
	filteredAgeGroup: string;
}

export const SectionDynamicDogByAge: React.FC<SectionDynamicDogByAgeProps> = ({
	currentDogId,
	maxItems,
	title,
	htmlIntro,
	jumpLinksTitle,
	filteredAgeGroup,
}) => {
	const parseAgeGroup = (ageGroupString: string) => {
		if (ageGroupString === "puppies") {
			return ["Under 6 months", "6 - 12 months"];
		}
		if (ageGroupString === "older_dogs") {
			return ["8 + years"];
		}
		return [ageGroupString];
	};

	const ageGroup = parseAgeGroup(filteredAgeGroup);

	return (
		<SectionDynamicDogBase
			currentDogId={currentDogId}
			maxItems={maxItems}
			title={title}
			htmlIntro={htmlIntro}
			jumpLinksTitle={jumpLinksTitle}
			sectionName="SectionDynamicDogByAge"
			searchVariables={{ age: ageGroup }}
			queryParams={{ age: ageGroup }}
		/>
	);
};

export default SectionDynamicDogByAge;
